import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { Paper, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { WHITE, PRIMARY_LIGHT_BLUE } from "../../colors";
import HeightBox from "../../components/HeightBox";
import CustomerService from "../../services/customerService";
import { getAge } from "../../util/calculations.utils";
import FormEditService from "../../services/formEditService";
import { POLICE_FORM } from "../../constants/formTypes";
import { useHistory } from "react-router-dom";
import { APPROVED, IN_DRAFT, NEW_FORM } from "../../constants/formStates";
import FormStateLabel from "./FormStateLabel";
import { PoliceReportPrintOut } from "../../components/Printouts/PoliceReportPrintOut";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: "#F5F6F8",
  borderRadius: 10,
  paddingTop: 20,
  paddingLeft: 20,
  paddingBottom: 20,
  opacity: 0.9,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
}));
const CustomTypography = styled(Typography)(({ theme }) => ({
  fontSize: 18,
}));
const CustomTextField = styled(TextField)(({ theme }) => ({
  width: 750,
  backgroundColor: WHITE,
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));
const CustomButton = styled(Button)(({ theme }) => ({
  paddingLeft: 10,
  backgroundColor: PRIMARY_LIGHT_BLUE,
  height: 42,
  minWidth: 155,
  color: WHITE,
  textTransform: "none",
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
}));
const ErrorMessage = styled(Typography)(({ theme }) => ({
  color: "red",
  fontSize: 13,
}));

const initialValues = {
  fullName: null,
  birthday: null,
  address: null,
  nationalId: null,
  passport: null,
};
export default function PoliceApplication(props) {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const [formValues, setFormValues] = useState(initialValues);
  const [pageInfo, setPageInfo] = useState({
    isDraft: false,
    isCreated: false,
  });
  let history = useHistory();
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const handleSubmit = async () => {
    const res = submitAndPrint();
  };
  const submitAndPrint = async () => {
    try {
      const res = await FormEditService.createFormEdit(formValues);
      alert("Successfully submitted the Application for Review");
      handlePrint();
      history.push("/forms");
      return true;
    } catch (e) {
      alert(e);
    }
  };

  useEffect(async () => {
    setIsDataLoaded(true);
    let newPageInfo = {
      isDraft: false,
      isCreated: false,
    };
    const getCustomer = async () => {
      const res = await CustomerService.getCustomerById(props.customer);
      return res.data;
    };
    const getFormDetails = async () => {
      const res = await FormEditService.getFormEditByCustomerAnType(props.customer, { type: POLICE_FORM });
      return res.data;
    };

    try {
      const { id, isDraft } = await getFormDetails();

      newPageInfo = {
        isDraft,
        isCreated: true,
      };
    } catch (error) {}

    const { dob, full_name, nic, address, passport } = await getCustomer();

    setFormValues({
      fullName: full_name,
      birthday: dob,
      customer: props.customer,
      type: POLICE_FORM,
      address,
      nationalId: nic,
      passport,
    });

    setPageInfo({ ...newPageInfo });
    setIsDataLoaded(false);
  }, [props.customer]);
  if (typeof props.customer !== "number") {
    return (
      <Container>
        <h2>Please select a customer</h2>
      </Container>
    );
  }

  return (
    <Container>
      <FormStateLabel type={pageInfo.isDraft ? IN_DRAFT : pageInfo.isCreated ? APPROVED : NEW_FORM} />
      <HeightBox height={10} />
      {isDataLoaded && (
        <Box
          sx={{
            width: "100%",
            height: "30vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={60} />
        </Box>
      )}
      {!isDataLoaded && (
        <>
          <Stack direction="row" spacing={5}>
            <Stack direction="column" spacing={2}>
              <HeightBox height={4} />
              <CustomTypography>Full Name:</CustomTypography>
              <HeightBox height={10} />
              <CustomTypography>Birthday:</CustomTypography>
              <HeightBox height={10} />
              <CustomTypography>Age:</CustomTypography>
            </Stack>
            <Stack direction="column" spacing={2}>
              <CustomTextField value={formValues.fullName} InputProps={{ disableUnderline: true, readOnly: true }} />
              <CustomTextField value={formValues.birthday} InputProps={{ disableUnderline: true, readOnly: true }} />
              <CustomTextField
                value={getAge(formValues.birthday)}
                InputProps={{ disableUnderline: true, readOnly: true }}
              />
            </Stack>
          </Stack>

          <HeightBox height={20} />
          <Stack direction="row-reverse">
            <div style={{ width: 640 }} />
            <div>
              {/* <ReactToPrint trigger={() => <CustomButton>Print</CustomButton>} content={() => componentRef.current} /> */}
              <div style={{ display: "none" }}>
                <PoliceReportPrintOut ref={componentRef} formValues={formValues} />
              </div>
            </div>
            {!pageInfo.isDraft && pageInfo.isCreated && (
              <CustomButton type="button" onClick={handlePrint}>
                Print{" "}
              </CustomButton>
            )}
            <div style={{ width: 20 }} />
            {!pageInfo.isDraft && pageInfo.isCreated && <CustomButton onClick={handleSubmit}>Submit </CustomButton>}
            <div style={{ width: 20 }} />
            {!pageInfo.isDraft && !pageInfo.isCreated && (
              <CustomButton onClick={handleSubmit}>Submit & Print </CustomButton>
            )}
          </Stack>
        </>
      )}
    </Container>
  );
}
